import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {FrmDenunciaComponent} from "./frm-denuncia.component";
import {
  DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxFormModule, DxNumberBoxModule,
  DxSelectBoxModule,
  DxTextAreaModule, DxTextBoxModule, DxValidationSummaryModule, DxValidatorModule
} from "devextreme-angular";
import { ReCaptchaModule } from 'angular2-recaptcha';

@NgModule({
  imports: [
    CommonModule, RouterModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxTextAreaModule,
    ReCaptchaModule,
  ],
  declarations: [FrmDenunciaComponent],
  exports: [FrmDenunciaComponent]
})
export class FrmDenunciaModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/frm-denuncia/frm-denuncia.module.ts